import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { CreateAuditContext } from "../../schema/types/auditctx/create";
import { AuditContext } from "../../schema/types/auditctx/entity";
import { AuditContextInput } from "../../schema/types/auditctx/input";
import { getDefaultBaseInput, OptimisticConcurrency } from "../../schema/types/base";

export function getDefaultAuditContextInput(): AuditContextInput {
  return {
    ...getDefaultBaseInput(),
    version: 0,
    id: "",
    meta: {
      isEdit: false,
    },
  };
}

export function inputToAuditContext(input: AuditContextInput): CreateAuditContext {
  const res: CreateAuditContext = {
    name: input.name,
    kind: "auditctx",
    tags: inputToTags(input.tags),
  };
  if (input.description) {
    res.description = input.description;
  }
  return res;
}

export function auditctxToInput(auditctx: AuditContext): AuditContextInput {
  const def = getDefaultAuditContextInput();
  const res: AuditContextInput = {
    ...def,
    version: auditctx.version,
    id: auditctx.id,
    name: auditctx.name,
    description: auditctx.description,
    tags: tagsToInput(auditctx.tags),
    meta: {
      ...def.meta,
      isEdit: true,
    },
  };
  return res;
}

export function auditctxToPatch(_auditctx: CreateAuditContext, concurrency: OptimisticConcurrency) {
  const auditctx: any = JSON.parse(JSON.stringify(_auditctx));

  auditctx[`$replace/tags`] = auditctx.tags;
  delete auditctx.tags;

  auditctx.id = concurrency.id;
  auditctx.version = concurrency.version;

  return auditctx;
}
